import PasteOptionButton from '../store/schema/PasteOptionButton';
import strings from 'owa-strings/owa-mail-strings';
import { ControlIcons } from 'owa-control-icons';

export default function getButtons(): PasteOptionButton[] {
    return [
        {
            key: 'PASTE_ORIGINAL',
            title: strings.pasteOptionPasteAsIsTooltip,
            shortcut: 'P',
            icon: ControlIcons.Paste,
        },
        {
            key: 'PASTE_TEXT',
            title: strings.pasteOptionPasteTextTooltip,
            shortcut: 'T',
            icon: ControlIcons.PasteAsText,
        },
    ];
}
